import {TemplateList} from "~/libs/constants/TemplateList"
import type StaticMenuItem from "~/libs/interfaces/StaticMenuItem"

export const MenuFooterPrivacyMenuConfig: Record<TemplateList, StaticMenuItem[]> = {
  [TemplateList.POGGERS]: [
    {
      name: 'Autorská práva k publikovaným materiálům',
      url: 'https://www.cncenter.cz/autorska-prava',
      target: "_blank"
    },
    {
      name: 'Podmínky pro užívání služby informační společnosti',
      url: 'https://www.cncenter.cz/podminky-uzivani',
      target: "_blank"
    },
    {
      name: 'Informace o zpracování osobních údajů',
      url: 'https://www.cncenter.cz/zasady-ochrany-osobnich-udaju',
      target: "_blank",
    },
    {
      name: 'Cookies',
      url: 'https://www.cncenter.cz/cookies',
      target: "_blank",
    },
    {
      name: 'Nastavení soukromí',
      url: 'javascript:Didomi.preferences.show()',
    },
    {
      name: 'Vlastnická struktura',
      url: 'https://www.cncenter.cz/o-nas',
      target: "_blank",
    },
    {
      name: 'Jednotná kontaktní místa / Single Points of Contact',
      url: 'https://www.cncenter.cz/jednotna-kontaktni-mista',
      target: "_blank",
    },
  ],
  [TemplateList.MATERIDOUSKA]: [
    {
      name: 'Autorská práva k publikovaným materiálům',
      url: 'https://www.cncenter.cz/autorska-prava',
      target: "_blank"
    },
    {
      name: 'Podmínky pro užívání služby informační společnosti',
      url: 'https://www.cncenter.cz/podminky-uzivani',
      target: "_blank"
    },
    {
      name: 'Informace o zpracování osobních údajů',
      url: 'https://www.cncenter.cz/zasady-ochrany-osobnich-udaju',
      target: "_blank",
    },
    {
      name: 'Cookies',
      url: 'https://www.cncenter.cz/cookies',
      target: "_blank",
    },
    {
      name: 'Nastavení soukromí',
      url: 'javascript:Didomi.preferences.show()',
    },
    {
      name: 'Vlastnická struktura',
      url: 'https://www.cncenter.cz/o-nas',
      target: "_blank",
    },
    {
      name: 'Jednotná kontaktní místa / Single Points of Contact',
      url: 'https://www.cncenter.cz/jednotna-kontaktni-mista',
      target: "_blank",
    },
  ]
}